import Cookies from 'js-cookie'

// App

const languageKey = 'langDaovay'
export const getLanguage =()=>{
   return Cookies.get(languageKey) || 'en'
}
export const setLanguage = (language) => Cookies.set(languageKey, language)

